import { inject } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { ConsoleService } from '@interacta-shared/data-access-configuration';
import {
    GenericAppBaseRoute,
    GenericAppRoute,
    GenericAppRouterState,
} from '@interacta-shared/util-common';
import { RouterStateSerializer } from '@ngrx/router-store';

export abstract class RouterSerializer<
    AR extends GenericAppRoute,
    BR extends GenericAppBaseRoute,
    T extends GenericAppRouterState<AR, BR>,
> implements RouterStateSerializer<T> {
    private readonly consoleService = inject(ConsoleService);

    protected abstract urlToAppRoute(url: string): AR | null;
    protected abstract toBaseRoute(appRoute?: AR | null): BR | null;

    serialize(routerState: RouterStateSnapshot): T {
        let root = routerState.root;
        let params = {};

        while (root.firstChild) {
            params = { ...params, ...root.firstChild.params };
            root = root.firstChild;
        }

        const {
            url,
            root: { queryParams },
        } = routerState;

        const appRoute = this.urlToAppRoute(url);
        const appBaseRoute = this.toBaseRoute(appRoute);

        if (appRoute === null) {
            this.consoleService.warningDev(
                'AppRouterSerializer.serialize(): appRoute is null with url' +
                    url,
            );
        }
        if (appBaseRoute === null) {
            this.consoleService.warningDev(
                'AppRouterSerializer.serialize(): appBaseRoute is null with url' +
                    url,
            );
        }

        return {
            url,
            params,
            queryParams,
            appRoute,
            appBaseRoute,
            data: root.data,
        } as T;
    }
}
